import styled, { css } from 'styled-components';

export const NoWrap = styled.span(
  () => css`
    white-space: nowrap;
  `,
);
